module.exports = __webpack_public_path__ + "e0106718/img/grid-web-icon.d0395d64.svg";